import {useContext} from "react";
import Context from "./talentFinderContext";

const useTalentFinderContext = () => useContext(Context);

export default useTalentFinderContext;
